import React from 'react';
import {Checkbox, Flex} from "antd";
import {t} from "i18next";
import FilterItemsTitle from "../../filter/FilterItemsTitle";

interface CompareFilterProps {
  selectedMetrics: Array<keyof TableMetrics>,
  setSelectedMetrics: Function,
}

export interface TableMetrics {
  kpi: string,
  kpi_long_term: string,
  kpi_short_term: string,
  cumulative: string,
  budget: string,
  roas: string,
  audienceText: string,
  managerText: string,
}

const metrics: Array<keyof TableMetrics> = [
  'kpi', 'kpi_short_term', 'kpi_long_term', 'cumulative', 'budget', 'roas', 'audienceText', 'managerText'
];

const getMetricName = (metric: string) => {
  switch (metric) {
    case 'kpi':
      return t('planner.kpiInTotals');
    case 'kpi_long_term':
      return t('planner.kpiLongTerm');
    case 'kpi_short_term':
      return t('planner.kpiShortTerm');
    case 'cumulative':
      return t('planner.cumulative');
    case 'budget':
      return t('planner.budget');
    case 'roas':
      return t('planner.roas');
    case 'audienceText':
      return t('factors.audienceText');
    case 'managerText':
      return t('factors.managerText');
    default:
      return ''
  }
};

export default function TableMetricsFilter({selectedMetrics, setSelectedMetrics}: CompareFilterProps) {
  return (
    <>
      <Flex vertical gap={6} justify={'center'}>
        <Flex className={'compare-filter__block'} vertical gap={'small'} justify={'center'}>
          <FilterItemsTitle title={t('planner.metricsName')} count={metrics.length}/>
          <Flex vertical gap={2}>
            {metrics.map(metric => (
              <Flex className={'compare-filter__item'} gap={'small'}>
                <Checkbox
                  checked={selectedMetrics.includes(metric)}
                  onChange={(event) => {
                    if (event.target.checked) {
                      setSelectedMetrics([
                        ...selectedMetrics,
                        metric,
                      ])
                    } else {
                      setSelectedMetrics([...selectedMetrics.filter(function (value, index, arr) {
                        return value !== metric
                      })])
                    }
                  }}
                />
                {getMetricName(String(metric))}
              </Flex>
            ))}
          </Flex>
        </Flex>
      </Flex>
    </>
  )
}
